import { z } from 'zod';
import { AnnotationWorkflowPayload } from './approve';
import { annotationWorkflowPayloadSchema } from './approve.schema';

export const reject = (
  annotationId: number,
  payload: AnnotationWorkflowPayload
) => {
  return {
    endpoint: `/annotations/${annotationId}/reject`,
    method: 'POST',
    responseSchema: z.unknown(),
    payload,
    payloadSchema: annotationWorkflowPayloadSchema,
  } as const;
};
